import { Tag, WithContext as ReactTags } from "react-tag-input";
import "./styles.scss";

type InputPedidosProps = {
  pedidos: Tag[];
  selected: Tag[];
  tagInputField: string
  handleAdd: (pedidos: Tag) => void;
  handleDel: (id: number) => void;
};

const InputPedidos = (props: InputPedidosProps) => {
  const KeyCodes = {
    comma: 188,
    enter: 13,
    space: 32,
  };
  const delimiters = [KeyCodes.comma, KeyCodes.enter, KeyCodes.space];
  return (
    <ReactTags
      placeholder="Inserir pedido"
      tags={props.selected}
      handleAddition={props.handleAdd}
      handleDelete={props.handleDel}
      delimiters={delimiters}
      suggestions={props.pedidos}
      autocomplete={true}
      allowDragDrop={false}
      inputFieldPosition="inline"
      shouldRenderSuggestions={(e) => e.length > 0}
      classNames={{ tagInputField: props.tagInputField,remove: "ps-2" }}      
    />
  );
};

export default InputPedidos;
